import { Injectable } from "@angular/core";
import { CHZoneData, CHZoneHelper } from "@app/area/model/ch-zone";
import { Observable } from "rxjs";
import {
    ClareHomeRPCMethodNames,
    ClareHomeRPCServiceNames,
    HDM_UTIL_METHODS,
    HZ_ACCESS_METHODS,
    HZ_ADMIN_METHODS,
} from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy";

@Injectable({
    providedIn: "root",
})
export class EquatorZonesService {
    private helper = new CHZoneHelper();

    constructor(readonly equatorProxyService: EquatorProxyService) {}

    get dbHelper() {
        return this.helper;
    }

    // There will be one of these in each equator-*.service class.
    // It supplies the JSON-RPC service name to the proxy.
    // Use this method in each method below.
    private call(
        uuid: string,
        method: ClareHomeRPCMethodNames,
        params: any[],
        service: ClareHomeRPCServiceNames = ClareHomeRPCServiceNames.HZ_ADMIN
    ) {
        return this.equatorProxyService.makeClareHomeRpcRequest$(
            uuid, // uuid
            service, // service
            method, // method
            params // params
        );
    }

    public addZoneDevice(uuid: string, zoneUid: string, deviceUid: string): Observable<any> {
        return this.call(uuid, HZ_ADMIN_METHODS.ADD_DEVICE, [zoneUid, deviceUid]);
    }

    public get(uuid: string): Observable<CHZoneData[]> {
        return this.call(uuid, HZ_ACCESS_METHODS.GET_HOME_ZONES, ["(!(UID=SYSTEM))"], ClareHomeRPCServiceNames.HZ_ACCESS);
    }

    public getFilteredZones(uuid: string, filter: string): Observable<any> {
        return this.call(uuid, HZ_ACCESS_METHODS.GET_HOME_ZONES, [filter], ClareHomeRPCServiceNames.HZ_ACCESS);
    }

    public removeZoneDevice(uuid: string, zoneUid: string, deviceUid: string): Observable<any> {
        return this.call(uuid, HZ_ADMIN_METHODS.REMOVE_DEVICE, [zoneUid, deviceUid]);
    }

    public setZoneDevices(uuid: string, zoneUid: string, devices: string[]): Observable<any> {
        return this.call(uuid, HDM_UTIL_METHODS.SET_DEVICES, [zoneUid, devices], ClareHomeRPCServiceNames.HDM_UTIL);
    }

    public add(uuid: string, zone: CHZoneData): Observable<CHZoneData> {
        return this.call(uuid, HZ_ADMIN_METHODS.ADD_HOME_ZONE, [null, zone]);
    }

    public edit(uuid: string, zoneUid: string, zoneName: string): Observable<any> {
        return this.call(uuid, HZ_ADMIN_METHODS.SET_NAME, [zoneUid, zoneName]);
    }

    public remove(uuid: string, zoneUid: string): Observable<any> {
        return this.call(uuid, HZ_ADMIN_METHODS.REMOVE_HOME_ZONE, [zoneUid]);
    }
}
